import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a cookie choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-screen-lg mx-auto bg-neutral-900 border border-neutral-800 rounded-lg p-6 shadow-2xl">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex-1">
                <h3 className="text-white font-semibold mb-2">Cookie Notice</h3>
                <p className="text-neutral-400 text-sm leading-relaxed">
                  We use cookies to enhance your browsing experience and analyse site traffic. 
                  By clicking "Accept", you consent to our use of cookies. 
                  Read our <Link to="/privacy-policy" className="text-white underline hover:no-underline">Privacy Policy</Link> for more information.
                </p>
              </div>
              <div className="flex gap-3 flex-shrink-0">
                <button
                  onClick={declineCookies}
                  className="px-5 py-2.5 text-sm font-medium text-neutral-400 hover:text-white border border-neutral-700 hover:border-neutral-500 rounded transition-colors"
                  data-testid="cookie-decline-btn"
                >
                  Decline
                </button>
                <button
                  onClick={acceptCookies}
                  className="px-5 py-2.5 text-sm font-medium text-black bg-white hover:bg-neutral-200 rounded transition-colors"
                  data-testid="cookie-accept-btn"
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
